module.exports = __webpack_public_path__ + "img/box2.b8ee8c40.svg";